(function () {
  var marks = [
    ['135', 'IGR — Institut für Gesundheit und Ergonomie'],
    ['327', 'Prüfengel — The German Institute for Product Testing'],
    ['515', 'TÜV Rheinland — ID 1111292061'],
    ['937', 'BIFMA']
  ];

  function addCertificationMarks() {
    if (document.querySelector('.office-chair-certification-marks')) return;

    var product = document.querySelector('.product');
    var mediaColumn = product && product.querySelector('.product__media-wrapper');
    var form = product && product.querySelector('.product-single__meta form.product-form');
    if (!product || (!mediaColumn && !form)) return;

    var benefitsAccordion = Array.prototype.find.call(product.querySelectorAll('.product__accordion'), function (accordion) {
      return /features and benefits/i.test(accordion.querySelector('.product__accordion-title-heading')?.textContent || '');
    });
    var strip = document.createElement('div');
    strip.className = 'office-chair-certification-marks';
    strip.setAttribute('aria-label', 'Shappa certification and standards marks');
    strip.innerHTML = marks.map(function (mark) {
      return '<span class="office-chair-certification-mark" role="img" aria-label="' + mark[1] + '" style="--crop-x:' + mark[0] + '"></span>';
    }).join('');

    function positionStrip() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (benefitsAccordion) benefitsAccordion.insertAdjacentElement('afterend', strip);
        else if (form) form.appendChild(strip);
      } else if (mediaColumn) {
        mediaColumn.appendChild(strip);
      } else if (form) {
        form.appendChild(strip);
      }
    }

    positionStrip();
    window.addEventListener('resize', positionStrip, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addCertificationMarks, { once: true });
  else addCertificationMarks();
})();
